import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import BadgeIcon from "../../../assets/images/BageIcon.webp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const BadgeCard = () => {
  const { kmCompleted } = useSelector((state) => state.routeReducer);
  const { nameBadge } = useSelector((state) => state.badgeReducer);

  const navigate = useNavigate();
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        backgroundColor: "rgba(212, 216, 216, 0.32)",
        borderRadius: 2,
        padding: 3,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Typography
              component="div"
              variant="h4"
              color="#e7ef7d"
              textAlign={"center"}
            >
              {kmCompleted} KM
            </Typography>
            <Typography component="div" variant="h5" textAlign={"center"}>
              Recorridos
            </Typography>
          </CardContent>
        </Box>
        <Box>
          <CardMedia
            component="img"
            sx={{ width: 161 }}
            image={BadgeIcon}
            alt="Live from space album cover"
          />
          <Typography component="div" variant="h5" textAlign={"center"}>
            {nameBadge ?? "Explorador Inicial"}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          startIcon={<WorkspacePremiumIcon />}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => navigate("/dashboard/list-badges")}
        >
          Ver más logros
        </Button>
      </Box>
    </Card>
  );
};
export default BadgeCard;
